import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ContactPerson,
  Event,
  Exhibitor,
  ExhibitorCardData,
  HtmlElementHelper,
  TabClickEvent,
} from '@planone/bau365/util-fair-data';
import { LinkClickEvent } from '@planone/shared/util-interfaces';

import * as DataAccessExhibitorsPageActions from './data-access-exhibitors.page.actions';

import {
  BrandSearchResultItem,
  CombinedSearchResultItem,
  ExhibitorSearchResultItem,
} from '../../../interfaces/exhibitor.interfaces';

@Injectable()
export class DataAccessExhibitorsPageFacade {
  constructor(private readonly store: Store) {}

  shareButtonClicked(
    network: string,
    item: ExhibitorCardData | CombinedSearchResultItem,
    fairId: string,
    pageContext: string,
    entityType: string
  ) {
    this.store.dispatch(
      DataAccessExhibitorsPageActions.exhibitorsShareButtonClicked({
        network: network,
        item: item,
        fairId: fairId,
        pageContext: pageContext,
        entityType: entityType,
      })
    );
  }

  shareButtonClickedContactPerson(
    network: string,
    exhibitor: Exhibitor,
    contactPerson: ContactPerson,
    entityType: string,
    fairId: string,
    pageContext: string,
    event?: Event
  ) {
    this.store.dispatch(
      DataAccessExhibitorsPageActions.exhibitorsShareButtonClickedContactPerson({
        network: network,
        exhibitor: exhibitor,
        contactPerson: contactPerson,
        entityType: entityType,
        fairId: fairId,
        pageContext: pageContext,
        event: event,
      })
    );
  }

  shareDialogOpened(
    contentType: string,
    pageContext: string,
    context: string,
    exhibitor: ExhibitorCardData | BrandSearchResultItem | ExhibitorSearchResultItem
  ) {
    this.store.dispatch(
      DataAccessExhibitorsPageActions.exhibitorsShareDialogOpened({
        contentType: contentType,
        pageContext: pageContext,
        context: context,
        exhibitor: exhibitor,
      })
    );
  }

  trackedItemClicked(clickedLinkInfo: LinkClickEvent) {
    this.store.dispatch(
      DataAccessExhibitorsPageActions.exhibitorsTrackedItemClicked({
        ...clickedLinkInfo,
        htmlElement: HtmlElementHelper.flattenObject(clickedLinkInfo.htmlElement),
      })
    );
  }

  trackClickShowAllToJumpToSearch(exhibitor: Exhibitor, entity_type: string, context: string) {
    this.store.dispatch(
      DataAccessExhibitorsPageActions.showAllToJumpToSearch({
        exhibitor_id: exhibitor.id,
        exhibitor_name: exhibitor.name,
        context,
        entity_type,
      })
    );
  }

  pageView(exhibitor_id: string, fair_id: string) {
    this.store.dispatch(DataAccessExhibitorsPageActions.exhibitorsPageView({ exhibitor_id, fair_id }));
  }

  tabClicked(tabClickInfo: TabClickEvent) {
    this.store.dispatch(DataAccessExhibitorsPageActions.exhibitorsTabClicked(tabClickInfo));
  }

  contactPersonPageView(exhibitor_id: string, contact_person_id: string) {
    this.store.dispatch(
      DataAccessExhibitorsPageActions.exhibitorsContactPersonPageView({ exhibitor_id, contact_person_id })
    );
  }
}
